import {AnimationItem} from 'lottie-web/build/player/lottie_light';
import {useRef, useState, useEffect, useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {AUTO_SCROLL_SPEED_OPTION_KEY} from './Setting';
import {pToast} from '../../common/container/PToast';
import useLocalStorage from '../../common/hook/useLocalStorage';
import useTypedSelector from '../../common/hook/useTypedSelector';
import {DEFAULT_VIEWER_SETTING} from '../../commonSub/hook/useViewerSettings';
import {actions} from '../state/actions';
import {IControlBtn} from '../type';

export default function useController() {
  const dispatch = useDispatch();
  const runModeRef = useRef<AnimationItem>();
  const [viewerState, isRunMode] = useTypedSelector(({viewer}) => [
    viewer.viewerState,
    viewer.isRunMode,
  ]);
  const [autoScrollSpeed] = useLocalStorage<number>({
    key: AUTO_SCROLL_SPEED_OPTION_KEY,
    initialValue: DEFAULT_VIEWER_SETTING.autoScrollSpeed,
  });
  const [isShowedAutoScrollToast, setIsShowedAutoScrollToast] = useState(false);
  const [isShow, setIsShow] = useState(true);
  const [selectedBtn, setSelectedBtn] = useState<IControlBtn | undefined>(
    undefined
  );

  const onClickComment = () => {
    dispatch(actions.setViewerState('comment'));
  };

  const onClickRunMode = () => {
    setSelectedBtn('run');
    if (!isRunMode) {
      pToast({
        desc: t => t('viewer_marathon_viewing_snackbar'),
        variant: 'black',
      });
      runModeRef.current?.goToAndPlay(0);
    } else {
      runModeRef.current?.stop();
    }
    dispatch(actions.setValue('isRunMode', !isRunMode));
  };

  const onClickAutoScroll = useCallback(
    ({showToast}: {showToast: boolean}) => {
      if (!isShowedAutoScrollToast && showToast) {
        pToast({
          desc: t => t('viewer_setting_autoscroll_toast'),
          variant: 'black',
        });
        setIsShowedAutoScrollToast(true);
      }
      dispatch(actions.setValue('autoScrollSpeed', autoScrollSpeed));
      dispatch(actions.setViewerState('none'));
    },
    [autoScrollSpeed, dispatch, isShowedAutoScrollToast]
  );

  useEffect(() => {
    setIsShow(viewerState === 'default');
  }, [isRunMode, viewerState]);

  useEffect(() => {
    if (!isShow && selectedBtn !== 'comment' && !isRunMode) {
      setSelectedBtn(undefined);
    }
  }, [isRunMode, isShow, selectedBtn]);

  return {
    isShow,
    isRunMode,
    runModeRef,
    onClickComment,
    onClickRunMode,
    onClickAutoScroll,
  };
}
